import { Component, ElementRef } from '@angular/core';
import { LayoutService } from '@common/services/layout.service';

@Component({
  selector: 'header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent {

  constructor(public layout: LayoutService, private ref: ElementRef) {  
  }

  public get nativeElement() {
    return this.ref.nativeElement as HTMLElement;
  }

  toggle() {
    this.layout.sidebar = !this.layout.sidebar;
  }
}
